export function formatErrorMessage(error: Error) {
  return new Error(`Error: ${error.message}`);
}
